module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/Lenox-0d0bd59d324c217f3137ef9cf30b9feb.png";